import { useQuery } from '@tanstack/react-query';
import { passwordResetApi } from '../api/passwordReset.api';

/**
 * Query: GET /api/eraf/auth/password-reset/verify?token=...
 * queryKey: ['passwordReset', 'verify', token]
 * Disabled when token is empty. retry: false — expired/invalid tokens must not retry.
 */
export function usePasswordResetVerify(token: string, enabled: boolean) {
  return useQuery({
    queryKey: ['passwordReset', 'verify', token],
    queryFn: () => passwordResetApi.verify(token),
    enabled: enabled && token.length > 0,
    retry: false,
    staleTime: 60_000, // 1 min — expiry state changes on server, not on cache
  });
}
